module.exports = __webpack_public_path__ + "static/media/IMG-4.a64181e9.jpg";